import React from "react";
import { Link } from "react-router-dom";
import { Inbox, ListChecks, ShieldAlert } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/auth/AuthProvider";

export const AdminOnlyScreen = ({ what = "This screen" }) => (
  <div className="mx-auto max-w-xl py-10" data-testid="admin-only-screen">
    <div className="vde-card p-6">
      <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-warning-surface">
        <ShieldAlert className="h-5 w-5 text-warning-text" aria-hidden="true" />
      </span>
      <h1 className="mt-3 text-base font-semibold tracking-tight">Admin access required</h1>
      <p className="mt-1 text-[13px] leading-relaxed text-muted-foreground">
        {what} is limited to admins because it can change how payments data is synced and exported.
        Your account has read-only access — ask an admin to promote you from Settings → Users &amp;
        access.
      </p>
      <div className="mt-4 flex flex-wrap gap-2">
        <Button asChild size="sm" className="gap-1.5">
          <Link to="/" data-testid="admin-only-inbox-link">
            <Inbox className="h-3.5 w-3.5" aria-hidden="true" /> Go to inbox
          </Link>
        </Button>
        <Button asChild size="sm" variant="outline" className="gap-1.5 bg-card">
          <Link to="/queue" data-testid="admin-only-queue-link">
            <ListChecks className="h-3.5 w-3.5" aria-hidden="true" /> View the queue
          </Link>
        </Button>
      </div>
    </div>
  </div>
);

export const RequireAdmin = ({ children, what }) => {
  const { isAdmin } = useAuth();
  if (!isAdmin) return <AdminOnlyScreen what={what} />;
  return children;
};
